/* eslint-disable @typescript-eslint/no-unsafe-return */
import { create } from "zustand";

type UsersTableStore = {
  usersTable: any;
  updateUsersTable: (usersTable: any) => void;
};

const useUsersTableStore = create<UsersTableStore>((set) => ({
  // state data and actions will go here
  usersTable: {
    workspace_identifier: "",
    include_count: true,
    page: 1,
    per_page: 10,
    filter: {},
    selected_fields: [
      "users.external_id",
      "users.name",
      "users.email",
      "users.avatar_url",
      "users.record_created_at",
      "users.last_seen"],
    metrics: [],
    sort: {
      field: "users.last_seen",
      order: "desc",
      type: "property",
    },
  } as any,
  updateUsersTable: (usersTable: any) => set(
    (state: any) => ({
      usersTable:
    { ...state.usersTable, ...usersTable },
    }),
  ),
}));

export default useUsersTableStore;
